import { Action, createReducer, on } from '@ngrx/store';
import { RolePermActions } from '../actions';
import { RolePermStates } from '../states';
import { rolePermAdapters, initialState } from '../states/role-permissions.states';

export const rolePermReducer = createReducer(
    initialState,
    
    // load roles in the role listing
    on(RolePermActions.loadRolesSuccess, (state, action) => ({...state, totalRecords: action.totalRecords})),
    on(RolePermActions.loadRolesFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // create new role
    on(RolePermActions.createRoleSuccess, (state, action) => ({...state, updateRoleListing: true})),
    on(RolePermActions.createRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update role
    on(RolePermActions.updateRoleSuccess, (state, action) => ({...state, updateRoleListing: true})),
    on(RolePermActions.updateRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete role
    on(RolePermActions.deleteRoleSuccess, (state, action) => ({...state, selectedGuid: null, selectedEntity: null, updateRoleListing: true})),
    on(RolePermActions.deleteRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(RolePermActions.deleteRoleWithPermsFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // add users to role
    on(RolePermActions.addUsersToRoleSucess, (state, action) => ({...state, updateUserRoleListing: true})),
    on(RolePermActions.addUsersToRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // remove users from role
    on(RolePermActions.removeUsersFromRoleSuccess, (state, action) => ({...state, updateUserRoleListing: true})),
    on(RolePermActions.removeUsersFromRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // add teams to role
    on(RolePermActions.addTeamsToRoleSuccess, (state, action) => ({...state, updateTeamRoleListing: true})),
    on(RolePermActions.addTeamsToRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // remove teams from role
    on(RolePermActions.removeTeamsFromRoleSuccess, (state, action) => ({...state, updateTeamRoleListing: true})),
    on(RolePermActions.removeTeamsFromRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // add permission sets to role
    on(RolePermActions.addPermSetsToRoleSuccess, (state, action) => ({...state, updateAllPermSetListing: true})),
    on(RolePermActions.addPermSetsToRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // remove permission sets from role
    on(RolePermActions.removePermSetsFromRoleSuccess, (state, action) => ({...state, updateAllPermSetListing: true})),
    on(RolePermActions.removePermSetsFromRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // add client side permissions to role
    on(RolePermActions.addClientSidePermsToRoleSuccess, (state, action) => ({...state, updateAllClientSideListing: true})),
    on(RolePermActions.addClientSidePermsToRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // remove permission sets from role
    on(RolePermActions.removeClientSidePermsFromRoleSuccess, (state, action) => ({...state, updateAllClientSideListing: true})),
    on(RolePermActions.removeClientSidePermsFromRoleFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // select
    on(RolePermActions.selectEntity, (state, action) => ({...state, selectedEntity: action.entity})),
    on(RolePermActions.selectGuid, (state, action) => ({...state, selectedGuid: action.guid})),
    on(RolePermActions.setDetailsForm, (state, action) => ({...state, detailsForm: action.form})),
    on(RolePermActions.setUpdateUserRoleListing, (state, action) => ({...state, updateUserRoleListing: action.update})),
    on(RolePermActions.setUpdateRoleListing, (state, action) => ({...state, updateRoleListing: action.update})),
    on(RolePermActions.setUpdateTeamRoleListing, (state, action) => ({...state, updateTeamRoleListing: action.update})),
    on(RolePermActions.setUpdateAllPermSetListing, (state, action) => ({...state, updateAllPermSetListing: action.update})),
    on(RolePermActions.setUpdateAllClientSideListing, (state, action) => ({...state, updateAllClientSideListing: action.update})),
)

export function role_perm_reducer(state: RolePermStates | undefined, action: Action) {
    return rolePermReducer(state.rolePerm, action);
}